{
  "TEAMS_SETTINGS": {
    "NEW_TEAM": "Utwórz nowy zespół",
    "HEADER": "Zespoły",
    "LOADING": "Fetching teams",
    "DESCRIPTION": "Teams allow you to organize agents into groups based on their responsibilities. An agent can belong to multiple teams. When working collaboratively, you can assign conversations to specific teams.",
    "LEARN_MORE": "Learn more about teams",
    "LIST": {
      "404": "Na tym koncie nie ma żadnych zespołów.",
      "EDIT_TEAM": "Edytuj zespół",
      "NONE": "Brak"
    },
    "CREATE_FLOW": {
      "CREATE": {
        "TITLE": "Utwórz nowy zespół",
        "DESC": "Dodaj tytuł i opis do swojego nowego zespołu."
      },
      "AGENTS": {
        "BUTTON_TEXT": "Dodaj agentów do zespołu",
        "TITLE": "Dodaj agentów do zespołu - {teamName}",
        "DESC": "Dodaj agentów do swojego nowo utworzonego zespołu. Dzięki temu możesz współpracować jako zespół w rozmowach oraz otrzymywać powiadomienia o nowych wydarzeniach w tej samej rozmowie."
      },
      "WIZARD_CREATE": {
        "TITLE": "Stwórz",
        "BODY": "Utwórz nowy zespół agentów."
      },
      "WIZARD_ADD_AGENTS": {
        "TITLE": "Dodaj agentów",
        "BODY": "Dodaj agentów do zespołu."
      },
      "WIZARD_FINISH": {
        "TITLE": "Zakończ",
        "BODY": "Wszystko jest gotowe!"
      }
    },
    "EDIT_FLOW": {
      "CREATE": {
        "TITLE": "Edytuj dane swojego zespołu",
        "DESC": "Edytuj tytuł i opis swojego zespołu.",
        "BUTTON_TEXT": "Aktualizuj zespół"
      },
      "AGENTS": {
        "BUTTON_TEXT": "Aktualizuj agentów w zespole",
        "TITLE": "Dodaj agentów do zespołu - {teamName}",
        "DESC": "Dodaj agentów do swojego nowo utworzonego zespołu. Wszyscy dodani agenci zostaną powiadomieni, gdy rozmowa zostanie przypisana do tego zespołu."
      },
      "EDIT_WIZARD_DETAILS": {
        "TITLE": "Szczegóły zespołu",
        "ROUTE": "settings_teams_edit",
        "BODY": "Zmień nazwę, opis i inne dane."
      },
      "EDIT_WIZARD_AGENTS": {
        "TITLE": "Edytuj agentów",
        "ROUTE": "settings_teams_edit_members",
        "BODY": "Edytuj agentów w zespole."
      },
      "EDIT_WIZARD_FINISH": {
        "TITLE": "Zakończ",
        "ROUTE": "settings_teams_edit_finish",
        "BODY": "Wszystko jest gotowe!"
      }
    },
    "TEAM_FORM": {
      "ERROR_MESSAGE": "Nie udało się zapisać szczegółów zespołu. Spróbuj ponownie."
    },
    "AGENTS": {
      "AGENT": "AGENT",
      "EMAIL": "EMAIL",
      "BUTTON_TEXT": "Dodaj agentów",
      "ADD_AGENTS": "Dodaj agenta do swojego zespołu...",
      "SELECT": "wybierz",
      "SELECT_ALL": "zaznacz wszystkich agentów",
      "SELECTED_COUNT": "{selected} z {total} agentów wybranych."
    },
    "ADD": {
      "TITLE": "Dodaj agentów do zespołu - {teamName}",
      "DESC": "Dodaj agentów do swojego nowo utworzonego zespołu. Dzięki temu możesz współpracować jako zespół w rozmowach oraz otrzymywać powiadomienia o nowych wydarzeniach w tej samej rozmowie.",
      "SELECT": "wybierz",
      "SELECT_ALL": "zaznacz wszystkich agentów",
      "SELECTED_COUNT": "{selected} z {total} agentów wybranych.",
      "BUTTON_TEXT": "Dodaj agentów",
      "AGENT_VALIDATION_ERROR": "Wybierz co najmniej jednego agenta."
    },
    "FINISH": {
      "TITLE": "Twój zespół jest gotowy!",
      "MESSAGE": "Możesz teraz współpracować jako zespół w rozmowach. Powodzenia w obsłudze klientów.",
      "BUTTON_TEXT": "Zakończ"
    },
    "DELETE": {
      "BUTTON_TEXT": "Usuń",
      "API": {
        "SUCCESS_MESSAGE": "Zespół został pomyślnie usunięty.",
        "ERROR_MESSAGE": "Nie można usunąć zespołu. Spróbuj ponownie."
      },
      "CONFIRM": {
        "TITLE": "Are you sure you want to delete the team?",
        "PLACE_HOLDER": "Wpisz {teamName}, aby potwierdzić",
        "MESSAGE": "Usuwanie zespołu spowoduje usunięcie przypisania zespołu z rozmów przypisanych do tego zespołu.",
        "YES": "Usuń ",
        "NO": "Anuluj"
      }
    },
    "SETTINGS": "Ustawienia",
    "FORM": {
      "UPDATE": "Aktualizuj zespół",
      "CREATE": "Utwórz zespół",
      "NAME": {
        "LABEL": "Nazwa zespołu",
        "PLACEHOLDER": "Przykład: Sprzedaż, Obsługa klienta"
      },
      "DESCRIPTION": {
        "LABEL": "Opis zespołu",
        "PLACEHOLDER": "Krótki opis tego zespołu."
      },
      "AUTO_ASSIGN": {
        "LABEL": "Włącz automatyczne przypisywanie dla tego zespołu."
      },
      "SUBMIT_CREATE": "Utwórz zespół"
    }
  }
}
